var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    className: "bob-core-components-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icons/home-"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.05 21H3.95c-.5 0-.95-.45-.95-.95v-7.6c0-.5.45-.95.95-.95h14.1c.5 0 .95.45.95.95v7.6c0 .5-.45.95-.95.95z",
    className: "secondarytint"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8V4.85c0-.5.4-.85.85-.85h1.3c.5 0 .85.4.85.85V6.5",
    className: "tertiarytint"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.67 10.1L12.47 5l-10.2 5.1c-.25.1-.35.4-.2.65.1.25.4.35.6.25l1.3-.65v9.3c0 .75.6 1.4 1.4 1.4h14.25c.75 0 1.4-.6 1.4-1.4v-9.3l1.3.65c.05.05.15.05.2.05.2 0 .35-.1.45-.3.05-.25-.05-.55-.3-.65zm-2.7 9.5c0 .2-.15.4-.4.4H5.37c-.2 0-.4-.15-.4-.4V9.85l7.5-3.75 7.5 3.75v9.75zm-14-13.1v-3c0-.3.2-.5.5-.5h3c.3 0 .5.2.5.5V5c0 .3-.2.5-.5.5s-.5-.2-.5-.5V4h-2v2.5c0 .3-.2.5-.5.5s-.5-.2-.5-.5zm5 5h-3c-.3 0-.5.2-.5.5v3c0 .3.2.5.5.5h3c.3 0 .5-.2.5-.5v-3c0-.3-.2-.5-.5-.5zm-.5 3h-2v-2h2v2z",
    className: "primarytint"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.bda88532b062f522b5bd9f8195501254.svg";
export { ForwardRef as ReactComponent };